import { render } from "./ProjectTeams.vue?vue&type=template&id=1b15cd4e&scoped=true"
import script from "./ProjectTeams.vue?vue&type=script&lang=js"
export * from "./ProjectTeams.vue?vue&type=script&lang=js"

import "./ProjectTeams.vue?vue&type=style&index=0&id=1b15cd4e&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b15cd4e"]])

export default __exports__